/* Soles District - grid boost (30 Oct 2026). See sections/sd-grid-boost.liquid.
   Sizes under each card, and Load more in place of page numbers - the first
   three batches load by themselves as you scroll, then the button takes over.

   BACK BUTTON. Coming back from a product used to re-download every page you
   had loaded, one after another, before it could scroll you back - slow on a
   phone. Now the cards you loaded are kept in sessionStorage as they arrive,
   so Back puts them straight back in and jumps to where you were, with no
   network wait. A fresh visit always starts at page 1. */
(function () {
  var DATA = {};
  var info = { page: 1, pages: 1, total: 0 };
  var busy = false;
  var extra = [];
  /* Scrolling near the bottom loads the next batch on its own, AUTO times per
     visit; after that the Load more button takes over. */
  var AUTO = 3, autoUsed = 0, io = null;
  var KEY = 'sdgb3:' + location.pathname + location.search;

  function readData(root) {
    root.querySelectorAll('script[data-sdgb]').forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        info = { page: j.__page || 1, pages: j.__pages || 1, total: j.__total || 0 };
        delete j.__page; delete j.__pages; delete j.__total;
        Object.keys(j).forEach(function (k) { DATA[k] = j[k]; });
      } catch (e) { /* leave cards as they are */ }
    });
  }

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function grid() { return document.getElementById('product-grid'); }
  /* Collections put the cards straight under #product-grid; search wraps them
     one level deeper. Find the cards wherever they are and append beside them. */
  function cards(root) { return root.querySelectorAll('li.grid__item'); }
  function list(g) { var c = cards(g)[0]; return c ? c.parentElement : g; }

  function decorateCard(li) {
    if (li.getAttribute('data-sdgb-done')) return;
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return;
    var d = DATA[handleOf(a)];
    if (!d || !d.v || !d.v.length) return;
    li.setAttribute('data-sdgb-done', '1');
    var box = li.querySelector('.card-information');
    if (!d.one && box) {
      box.appendChild(el('div', 'sdgb-sizes', d.v.map(function (x) { return x[1]; }).join(' · ')));
    }
  }

  function decorateAll() {
    var g = grid();
    if (!g) return;
    cards(g).forEach(decorateCard);
    setupMore();
  }

  function pageUrl(n) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', n);
    return u.toString();
  }

  function setupMore() {
    var g = grid();
    if (!g) return;
    var host = g.parentElement;
    var box = host.querySelector('.sdgb-more');
    host.classList.add('sdgb-hide-pages');
    var shown = cards(g).length;
    if (info.page >= info.pages) { if (box) box.remove(); return; }
    if (!box) {
      box = el('div', 'sdgb-more');
      box.appendChild(el('p', 'sdgb-count'));
      var bar = el('div', 'sdgb-bar'); bar.appendChild(el('span'));
      box.appendChild(bar);
      var btn = el('button', 'sdgb-morebtn', 'Load more');
      btn.type = 'button';
      btn.addEventListener('click', loadMore);
      box.appendChild(btn);
      g.insertAdjacentElement('afterend', box);
      watchBox(box);
    }
    box.querySelector('.sdgb-count').textContent = 'Showing ' + shown + ' of ' + info.total;
    box.querySelector('.sdgb-bar span').style.width = Math.min(100, Math.round(shown / Math.max(info.total, 1) * 100)) + '%';
  }

  function watchBox(box) {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || busy || autoUsed >= AUTO) return;
      autoUsed++;
      loadMore();
    }, { rootMargin: '0px 0px 800px 0px' });
    io.observe(box);
  }

  function loadMore() {
    if (busy || info.page >= info.pages) return Promise.resolve();
    busy = true;
    var btn = document.querySelector('.sdgb-morebtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Loading…'; }
    return fetch(pageUrl(info.page + 1))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        readData(doc);
        var g = grid();
        var next = doc.getElementById('product-grid');
        var added = [];
        if (g && next) {
          var into = list(g);
          cards(next).forEach(function (li) {
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            var node = document.importNode(li, true);
            into.appendChild(node);
            added.push(node);
          });
        }
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = 'Load more'; }
        decorateAll();
        var b = document.querySelector('.sdgb-more');
        if (io && b && autoUsed < AUTO) { io.unobserve(b); io.observe(b); }
        added.forEach(function (n) { extra.push(n.outerHTML); });
        save();
      })
      .catch(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = 'Load more'; }
      });
  }

  /* The browser gives each site about 5MB here, roughly 20 batches of cards.
     Past that the cards are not kept, only how far you got and where you were,
     and Back re-downloads the batches instead - slower, but you still land
     where you left off rather than at the top. */
  function save() {
    if (info.page < 2) return;
    var base = { page: info.page, pages: info.pages, total: info.total, y: window.scrollY };
    try {
      base.html = extra.join('');
      sessionStorage.setItem(KEY, JSON.stringify(base));
    } catch (e) {
      delete base.html;
      try { sessionStorage.setItem(KEY, JSON.stringify(base)); } catch (e2) {}
    }
  }

  /* Returns true when it put a previous session back. */
  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!nav || nav.type !== 'back_forward' || !saved || !(saved.page > 1)) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      return false;
    }
    var g = grid();
    if (!g) return false;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (!saved.html) {
      decorateAll();
      autoUsed = AUTO;
      var y = saved.y || 0, target = saved.page;
      var prev = 0;
      (function step() {
        if (info.page >= target || info.page >= info.pages || info.page === prev) { window.scrollTo(0, y); return; }
        prev = info.page;
        loadMore().then(step);
      })();
      return true;
    }
    list(g).insertAdjacentHTML('beforeend', saved.html);
    extra = [saved.html];
    info = { page: saved.page, pages: saved.pages, total: saved.total };
    autoUsed = Math.min(AUTO, saved.page - 1);
    decorateAll();
    window.scrollTo(0, saved.y || 0);
    requestAnimationFrame(function () { window.scrollTo(0, saved.y || 0); });
    return true;
  }

  /* Filters and sorting re-render #ProductGridContainer from the grid section
     alone, so this section's data goes stale. Re-read the whole page then. */
  function watchFilters() {
    var c = document.getElementById('ProductGridContainer');
    if (!c || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      var g = grid();
      if (!g || g.getAttribute('data-sdgb-seen')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var g2 = grid();
        if (!g2) return;
        g2.setAttribute('data-sdgb-seen', '1');
        KEY = 'sdgb3:' + location.pathname + location.search;
        extra = [];
        autoUsed = 0;
        fetch(window.location.href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            readData(new DOMParser().parseFromString(html, 'text/html'));
            decorateAll();
          });
      }, 150);
    }).observe(c, { childList: true, subtree: true });
  }

  function init() {
    readData(document);
    var g = grid();
    if (g) g.setAttribute('data-sdgb-seen', '1');
    if (!restore()) decorateAll();
    watchFilters();
    window.addEventListener('pagehide', save);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#product-grid a[href]')) save();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
